import { Component, OnInit, NgZone, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from '../../../shared/utils/dateValidator.validator';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
declare const google: any;
declare module 'googlemaps';

@Component({
  selector: 'app-create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.css']
})
export class CreateEventComponent implements OnInit {
  @ViewChild('imageInput') imageInput!: ElementRef;
  form: FormGroup;
  customCategory: FormArray;
  submitted = false
  errorMessage
  model: NgbDateStruct;
  modelSecond: NgbDateStruct
  datesArray = [];
  hourArray = []
  gallaryArr = []
  loading = false;
  selectedItem
  eventImage = ''
  closeResult = '';
  showImage = false
  showDays = false;
  showhours = false
  notifyAttendersValue = false;
  notifyvisitorsValue = false
  startTime = { hour: 0, minute: 0 };
  endTime = { hour: 0, minute: 0 };
  baseUrl = environment.imgUrl;
  selectedFile: File | null = null;

  allAddress = ""
  constructor(private authService: AuthservicesService, private modalService: NgbModal, private fb: FormBuilder, private router: Router, private zone: NgZone) {

    // const today: string = moment().format('D MMM YYYY');

    // console.log(today)
  }
  ngOnInit() {
    this.getGallary();
    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({
      eventName: ['', Validators.required],
      description: ['', Validators.required],
      validFrom: ['', Validators.required],
      locationName: [''],
      validTill: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      photo: ['', Validators.required],
      address: ['', Validators.required],
      notifyFollowers: [false],
      notifyAttenders: [false],
      notifyVisitorsBefore: [''],
      notifyAttenderBefore: [''],
      accessibility: ['', Validators.required]
    },
      {
        validator: MustMatch('validFrom', 'validTill')
      })
  }

  get f() {
    return this.form.controls;
  }

  open(content) {

    this.modalService.open(content, { centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    // const startTimeString = this.onTimeChange(this.startTime);
    // const endTimeString = this.onTimeChange(this.endTime);

    this.form.get('startTime').setValue(this.startTime);
    this.form.get('endTime').setValue(this.endTime);


    this.authService.createEvents(this.form.value).subscribe((res: any) => {
      this.messageAlert(res.message, 'success')
      this.router.navigate(['/event-manager'])

    },
      error => {
        this.messageAlert(error.error.message, 'error')
      })
  }
  selectImage(props, index) {
    this.selectedItem = index;
    this.eventImage = props;
  }

  addImageToGallery(imagePath: string) {
    if (!imagePath || typeof imagePath !== 'string') {
      console.error('Invalid image path');
      return;
    }

    const fullUrl = `${this.baseUrl}uploads/${imagePath}`;
    this.gallaryArr.push({ url: fullUrl });
    console.log('Image added:', fullUrl);
  }


  getGallary() {
    this.authService.getPhotoGallery(0, 10).subscribe((res: any) => {
      console.log("res>>>>>>>>", res.items)
      this.gallaryArr = res.items
      this.loading = true
    },
      error => {
        console.log(error)
      })
  }

  handle(e){
    const file = e.target.files[0];
    console.log("file>>>>>>>>>>", file)
  if (file) {
    const fullUrl = `${this.baseUrl}uploads/${file.name}`; // Construct URL based on file name
    this.gallaryArr.push({ url: fullUrl });
    console.log('Image added:', fullUrl);
  }
  }

  renderImage(image: any): string {
    // Explicitly extract the URL
    const imageUrl = image?.url || image;

    if (!imageUrl) {
      return 'assets/images/church.jpeg';
    }

    // Ensure the URL is a string and handle uploads
    if (typeof imageUrl === 'string') {
      // Remove any potential leading slash
      const cleanUrl = imageUrl.startsWith('/') ? imageUrl.slice(1) : imageUrl;

      // Construct full URL
      return `${this.baseUrl}${cleanUrl}`;
    }

    // Fallback to default image
    return 'assets/images/church.jpeg';
  }

  check(event: any, type: any) {
    if (event.target.checked && (type == 'visitors' || type == 'attendees')) {
      this.findDiff(type)
    }
    else {
      this.showhours = false;
      this.showDays = false;
    }
  }


  addimageForm() {
    this.showImage = true
    this.form.get('photo').setValue(this.eventImage)
  }



  // findDiff(type) {
  //   if (this.model && this.modelSecond) {
  //     this.hourArray = []
  //     let diffdate = moment(this.modelSecond).diff(moment(this.model), 'days')
  //     if (type == "attendees") {
  //       this.notifyAttendersValue = true
  //       this.hourArray = []
  //       this.showhours = true
  //       this.form.get('notifyAttenders').setValue(true)

  //       if (diffdate == 0) {
  //         this.hourArray.push(1)
  //       }
  //       else if (diffdate != 0) {
  //         diffdate = 23
  //         for (let i = 0; i < diffdate; i++) {
  //           this.hourArray.push(i + 1)
  //         }
  //       }
  //     }
  //     else if (type == 'visitors') {
  //       this.datesArray = []
  //       this.showDays = true
  //       this.form.get('notifyVisitors').setValue(true)
  //       if (diffdate == 0) {
  //         this.datesArray.push(1)
  //       }
  //       else if (diffdate != 0) {
  //         diffdate = 30
  //         for (let i = 0; i < diffdate; i++) {
  //           this.datesArray.push(i + 1)
  //           this.showDays = true

  //         }
  //       }
  //     }
  //   }
  // }

  findDiff(type) {
    let today = new Date();

    if (this.model && this.modelSecond) {
      this.hourArray = [];
      let diffdate = moment(this.modelSecond).diff(moment(this.model), 'days')
      let startEventBeforeDays = moment(this.model).diff(moment(today), 'days')
      let startEventBeforehrs = moment(this.model).diff(moment(today), 'hours')

      if (type == "attendees") {
        this.notifyAttendersValue = true
        this.hourArray = []
        this.showhours = true
        this.form.get('notifyAttenders').setValue(true)

        if (startEventBeforehrs > 0) {
          for (let i = 0; i < startEventBeforehrs; i++) {
            this.hourArray.push(i + 1)
          }
        }
        else if (type == 'visitors') {
          for (let i = 0; i < startEventBeforehrs; i++) {
            this.hourArray.push(i + 1)
          }
          this.datesArray = []
          this.showDays = true
          this.form.get('notifyFollowers').setValue(true)
          if (startEventBeforeDays == 0) {
            this.datesArray.push(1)
          }
          else if (startEventBeforeDays != 0) {
            for (let i = 0; i < startEventBeforeDays; i++) {
              this.datesArray.push(i + 1)
              this.showDays = true
            }
          }
        }
      }
      else if (type == 'visitors') {
        this.datesArray = []
        diffdate = 23
        for (let i = 0; i < startEventBeforehrs; i++) {
          this.hourArray.push(i + 1)
        }
        this.showDays = true
        this.form.get('notifyFollowers').setValue(true)
        if (startEventBeforeDays == 0) {
          this.datesArray.push(1)
        }
        else if (startEventBeforeDays != 0) {
          for (let i = 0; i < startEventBeforeDays; i++) {
            this.datesArray.push(i + 1)
            this.showDays = true
          }
        }
      }
    }
  }


  AddressChange(address: any,) {
    let obj = {
      streetAddress: "",
      city: "",
      location: "",
      state: "",
      googleAddress: "",
      postalCode: "",
      country: "",
      suite_no: "",
      landMark: ""
    }
    this.zone.run(() => {
      this.createArray(address, obj)
    }
    )
  }

  createArray(address, addressobj) {
    let latitude = address.geometry.location.lat();
    let longitude = address.geometry.location.lng();

    addressobj['streetAddress'] = address.formatted_address
    addressobj['googleAddress'] = (address.name) ? address.name : ''
    addressobj['location'] = { "type": "Point", "coordinates": [longitude, latitude] }

    let address_components = address.address_components;
    for (let i = 0; i < address_components.length; i++) {
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        addressobj['city'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'administrative_area_level_1') {
        addressobj['state'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'country') {
        addressobj['country'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'postal_code') {
        addressobj['postalCode'] = address_components[i].long_name || '';
      }
    }
    this.form.get('address').setValue(addressobj)
  }



  messageAlert(message, type) {
    this.authService.successMessage(message, type)
  }


  loaded(event, className) {
    this.authService.loadImage(event, className)
  }


  getErrorImage(event: any) {
    event.target.src = 'assets/images/church.jpeg';
  }

  onTimeChange(value: { hour: any, minute: any }) {
    console.log(value)
    return `${value.hour}:${value.minute}`;
  }

  selectDay(props: any){
    this.form.controls['notifyVisitorsBefore'].setValue(props)
  }

  selectHours(props: any){
    this.form.controls['notifyAttenderBefore'].setValue(props);
  }

}

